<template>
  <div class="centerPage">
    <div class="search flex">
      <div>
        <span class="tit">结账单</span>
      </div>
      <div class="flex">
        <el-input placeholder="账单号/预约号" clearable v-model="search.keyword" @change="skipPage(1)"></el-input>
        <el-button size="mini" @click="skipPage(1)">搜索</el-button>
      </div>
    </div>
    <div class="border">
      <el-table
          v-if="page.rows.length!==0"
          class="record-table"
          :data="page.rows"
          :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
          height="calc(100vh - 357px)">
        <el-table-column prop="billNo" label="账单号" align="center" width="150"></el-table-column>
        <el-table-column prop="orderNo" label="订单号" align="center" width="150">
          <template slot-scope="scope">
            <a href="javascript:void(0)" style="color: cornflowerblue"
               @click="orderDetails(scope.row)">{{ scope.row.orderNo }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="billTimestamp" align="center" label="账单时间">
          <template slot-scope="scope">{{ new Date(scope.row.billTimestamp).Format('yyyy-MM-dd HH:mm:ss') }}</template>
        </el-table-column>
        <el-table-column label="结账类型" align="center" width="100">
          <template slot-scope="scope">{{ BILL_TYPES[scope.row.billType] }}</template>
        </el-table-column>
        <el-table-column label="结账状态" align="center" width="100">
          <template slot-scope="scope">
            <span :state="scope.row.billStatus">{{ BILL_STATUS[scope.row.billStatus] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单金额" align="center" width="120">
          <template slot-scope="scope">
            <span>{{ (scope.row.orderTotalAmount / 100).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="实际支付" align="center" width="120">
          <template slot-scope="scope">
            <span class="disabled">{{ (scope.row.orderActualAmount / 100).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="已结金额" align="center" width="120">
          <template slot-scope="scope">
            <span class="disabled">{{ (scope.row.settledAmount / 100).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-button @click="billDetails(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="empty" v-else>
        <img src="../../assets/img/no.png" alt="" width="200">
        <p>这里什么都没有</p>
      </div>
      <el-pagination
          class="pagination"
          background
          prev-text="Prev"
          next-text="Next"
          :current-page="page.current"
          :page-size="page.size"
          layout="prev, pager, next"
          :total="page.total"
          @current-change="skipPage">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="billDetailDialog.show"
               top="0"
               :close-on-click-modal="false"
               :close-on-press-escape	="false"
               :show-close	="false"
               @close="billDetailDialog.items.length=0"
               title="结算明细列表">
      <el-table :data="billDetailDialog.items">
        <el-table-column label="结算时间" align="center">
          <template slot-scope="scope">{{new Date(scope.row.settleTimestamp).Format('yyyy-MM-dd HH:mm')}}</template>
        </el-table-column>
        <el-table-column label="结算金额" align="center" width="120">
          <template slot-scope="scope">
            <span>{{(scope.row.settleAmount/100).toFixed(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="凭证" prop="voucher" align="center"></el-table-column>
        <el-table-column label="备注" prop="remark" align="center"></el-table-column>
      </el-table>
      <div slot="footer">
        <el-button style="width: 70px; margin-left: 20px; height: 28px;" size="small" @click="billDetailDialog.show=false">关闭</el-button>
      </div>
    </el-dialog>

    <!--  appoint details dialog  -->
    <el-dialog :visible.sync="appointDialog.show" top="0" title="预约详情" :show-close="false">
      <div style="overflow-y: auto; max-height: 500px;">
        <div class="appoint-body" v-for="appoint in appointDialog.appoints" :key="appoint.id">
          <h3>预约号: {{appoint.appointNo}}</h3>
          <div class="body-item">
            <p><label>预约时间:</label>{{appoint.appointDateShow}}</p>
          </div>
          <div class="body-item">
            <span><label>咨询方式:</label>{{appoint.consultMode === 1 ? '语音' : '视频'}}</span>
            <span><label>咨询语言:</label>{{appoint.consultLanguage}}</span>
          </div>
          <div class="body-item">
            <span><label>姓名:</label>{{appoint.realName}}</span>
            <span><label>性别:</label>{{appoint.gender == 1 ? '男' : appoint.gender == 0 ? '女' :'-'}}</span>
            <span style="width: 100px;"><label>年龄:</label>{{appoint.age}}岁</span>
          </div>
          <div class="body-item">
            <span><label>所在城市:</label>{{appoint.abodeCity}}</span>
            <span><label>职业:</label>{{appoint.occupation}}</span>
          </div>
          <div class="body-item"><label>问题描述:</label>{{appoint.problemDesc}}</div>
          <div class="body-item"><label>期望效果:</label>{{appoint.expectEffect}}</div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="appointDialog.show=false;appointDialog.appoints.length=0;">关闭</el-button>
      </div>
    </el-dialog>



  </div>
</template>

<script>
import base from '@/api/common';
export default {
    name: "checkOut",
    data() {
        return {
            BILL_TYPES:['-','预约单','月卡','年卡','测试单'],
            BILL_STATUS:['未结算','部分结算','已结清'],
            search:{
                keyword: '',
            },
            page: {
                current: 1,
                size: 10,
                total: 0,
                rows:[]
            },

            billDetailDialog:{
              show: false,
              items: []
            },

            appointDialog:{
              show: false,
              user: {},
              appoints:[],
            }
        }
    },
    methods: {
        skipPage(current){
            this.page.current = current;
            this.getData();
        },
        getData() {
            let that = this;
            that.$ajax.post(base.basePath + 'financial/settlement-bill/authorize/doctor/page',{
                page: that.page.current,
                size: that.page.size,
                keyword: that.search.keyword
            }).then(res=>{
                if(res.data.status === 'success'){
                    that.page.current = res.data.current;
                    that.page.size = res.data.size;
                    that.page.total = res.data.total;
                    that.page.rows = res.data.rows;
                }else{
                    that.$message.error('数据加载失败');
                }
            }).catch(err=>{
                console.error(err);
                that.$message.error('数据加载失败');
            })
        },
        billDetails(item){
          this.billDetailDialog.show = true;
          this.$ajax.get(base.basePath + 'financial/settlement-bill-item/authorize/list/'+item.id).then(res=>{
            if(res.data.status === 'success'){
                this.billDetailDialog.items = res.data.list;
            }else{
                this.$message.error(res.data.message);
            }
          }).catch(err=>{
            console.error(err);
            this.$message.error('账单信息加载失败');
          })
        },
        orderDetails(item){
            let that = this;
            let billType = item.billType;
            let orderNo = item.orderNo;
            if(billType == 1){
              that.appointDialog.show = true;
              that.$ajax.get(base.api.appoint.details_doctor.replace('{no}',orderNo)).then(res=>{
                if(res.data.status === 'success'){
                  if(res.data.data.appointStartLongtime && res.data.data.appointEndLongtime){
                    let startDate = new Date(res.data.data.appointStartLongtime);
                    let endDate = new Date(res.data.data.appointEndLongtime);
                    if(Number(startDate.Format('yyyyMMdd')) === Number(endDate.Format('yyyyMMdd'))){ //同天
                      res.data.data.appointDateShow = startDate.Format('yyyy-MM-dd HH:mm') + ' ~ ' + endDate.Format('HH:mm');
                    }else{
                      res.data.data.appointDateShow = startDate.Format('yyyy-MM-dd HH:mm') + ' ~ ' + endDate.Format('yyyy-MM-dd HH:mm');
                    }
                  }
                  that.appointDialog.appoints.push(res.data.data);
                }else{
                    that.$message.error(res.data.message);
                }
              }).catch(err=>{
                console.error(err);
                that.$message.error('预约详情加载失败');
              })
            }else if(billType == 2 || billType == 3){ // 月卡 or 年卡
              that.appointDialog.show = true;
              that.$ajax.get(base.basePath + 'medical/medical-appoint/authorize/list/coupon/'+orderNo).then(res=>{
                if(res.data.status === 'success'){
                  that.appointDialog.appoints = res.data.list;
                }else{
                  that.$message.error(res.data.message);
                }
              }).catch(err=>{
                console.log(err);
                that.$message.error('预约详情加载失败');
              });
            }else if(billType == 4){
              console.log('测试单: ' + orderNo);
            }else{
              that.$message.error('类型错误');
            }
        }
    },
    mounted() {
        this.getData();
    },
}
</script>

<style scoped lang="scss">
@import '../../assets/css/patients.scss';
.blue{
    color: #567BFF;
}
.search div:first-child{
    width: 50%;
}
.orange{
    font-size:13px;
    color: #FC7B66;
    margin-left: 5%;
}

button{
    padding: 4px 12px;
    background: #567BFF;
    color: #ffffff;
}
span[state] {
  display: inline-block;
  width: 80px;
  height: 28px;
  line-height: 28px;
  text-align: center
}
span[state='0'] {color: #606266;background-color: #DCDFE6}
span[state='1'] {color: #E6A23C;background-color: #FAECD8}
span[state='2'] {color: #67C23A;background-color: #E1F3D8}

div.appoint-body{
  padding: 0 30px;
  h3{
    border-bottom: 1px solid rgba(86, 123, 255, 0.5);
    color: #567BFF;
    font-size: 18px;
  }
  label{
    font-weight: 900;
    margin-right: 8px;
    font-size: 13px;
  }
  .body-item{
    margin: 14px 0;
    line-height: 1.2rem;
    padding-left: 12px;
    span{
      display: inline-block;
      width: 200px;
    }

  }
}

</style>
